export default function LotusMark({ className = "w-8 h-8" }) {
  return (
    <svg
      viewBox="0 0 64 64"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M32 14c4.2 6.2 4.2 13.6 0 19.8-4.2-6.2-4.2-13.6 0-19.8Z" />
      <path d="M18.5 22.5c7 .8 12.4 5.8 14.6 12.6-7.2-.4-13.3-5.4-14.6-12.6Z" />
      <path d="M45.5 22.5c-7 .8-12.4 5.8-14.6 12.6 7.2-.4 13.3-5.4 14.6-12.6Z" />
      <path d="M10 36c8.5.4 16.4 4.8 22 12-8.9.6-18.2-3.6-22-12Z" />
      <path d="M54 36c-8.5.4-16.4 4.8-22 12 8.9.6 18.2-3.6 22-12Z" />
    </svg>
  );
}
